export const surveyDatePromptIds = [
  'instant_survey_date_range',
  'instant_survey_date_range_no_lag',
];

export const surveyDescriptionDefault = 'Standard Survey (6-15 Questions)';
export const surveyDescriptionLong = 'Long Survey (16-20 Questions)';
export const surveyDescriptionShort = 'Short Survey (1-5 Questions)';

export const surveyLengthLong = 16;
export const surveyLengthShort = 5;

/* eslint-disable perfectionist/sort-objects */
export const addonTypes = {
  CUSTOM_DATA_TABLES: 1,
  CUSTOM_PROGRAMMING: 2,
  WRITE_QUESTIONNAIRE: 3,
  TRANSLATE_SURVEY_FRENCH: 4,
  BRAND_TRACKING: 5,
  COMPETITIVE_ANALYSIS: 6,
  CUSTOM_QUESTIONS: 7,
  TRANSLATE_SURVEY_SPANISH: 8,
  TURF: 9,
  CONSULTATION: 10,
  SAMPLE_SETUP: 11,
  PROGRAM_SURVEY: 12,
  MAX_DIFF: 13,
  PPG: 14,
  NEW_ITEM_TAG: 15,
  OTHER: 16,
};

export const surveyStatus = {
  CREATED: 1,
  PUBLISHING: 2,
  PUBLISHED: 3,
  FIELDING: 4,
  FIELDED: 5,
  COMPLETED: 6,
  EXCEPTION: 7,
  LOW_SAMPLE: 8,
  INCOMPLETE: 9,
  MET_SAMPLE: 10,
  IN_REVIEW: 11,
  DRAFT: 12,
};
/* eslint-enable perfectionist/sort-objects */

export const completedSurveyStatuses = [surveyStatus.MET_SAMPLE, surveyStatus.COMPLETED];
export const pausableSurveyStatuses = [
  surveyStatus.CREATED,
  surveyStatus.PUBLISHING,
  surveyStatus.PUBLISHED,
  surveyStatus.IN_REVIEW,
  surveyStatus.FIELDING,
  surveyStatus.FIELDED,
];
export const pausedEditableSurveyStatuses = [
  surveyStatus.PUBLISHING,
  surveyStatus.PUBLISHED,
  surveyStatus.IN_REVIEW,
];
export const pausedReadOnlySurveyStatuses = [surveyStatus.FIELDING, surveyStatus.FIELDED];

export const surveyTypeQuestionId = {
  'ask-why-instant-survey-type': 'ask_why_questions',
  'buyer-instant-survey-type': 'buyer_questions',
  'buyer-v2-instant-survey-type': 'buyer_questions',
  'concept-screening-instant-survey-type': 'test_panel_questions',
  'concept-screening-v2-instant-survey-type': 'test_panel_questions',
  'lapsed-repeat-new-instant-survey-type': 'lapsed_repeat_new_questions',
  'lapsing-brand-instant-survey-type': 'lapsing_brand_survey_questions',
  'lapsing-brand-v2-instant-survey-type': 'lapsing_brand_survey_questions',
  'leakage-instant-survey-type': 'leakage_survey_questions',
  'leakage-v2-instant-survey-type': 'leakage_survey_questions',
  'quick-pulse-instant-survey-type': 'quick_pulse_questions',
  'quick-pulse-v2-instant-survey-type': 'quick_pulse_questions',
  'test-survey-instant-survey-type': 'test_survey_questions',
};

export const customFolderId = 2;
export const recommendedFolderId = 1;

export const defaultGroupName = 'Panelist Group';
export const defaultResponseCount = 200;
export const maxQuestionError = 'Maximum number of questions has been reached.';
export const maxVideoQuestionError = 'Maximum number of video questions has been reached.';
export const minAskWhyCredits = 0.5;
export const minQuestions = 1;
export const minSampleSize = 50;
export const responseCountIncrement = 50;
export const responseCountMinimum = 50;
export const instantSurveyGroupRefUrlVariable = 'instant_survey_group_ref';

export const placeholderImage =
  'https://www.numerator.com/sites/default/files/2023-03/DW%20WEB%20HEADER-100_0_0.jpg';

export const questionLogicOperators = {
  ALL: {
    text: 'All of the Following',
    value: 'ALL',
  },
  ANY: {
    text: 'Any of the Following',
    value: 'ANY',
  },
  EQUALS: {
    text: 'Equal to',
    value: 'EQUALS',
  },
  GREATER_THAN: {
    text: 'Greater Than',
    value: 'GREATER_THAN',
  },
  GREATER_THAN_OR_EQUAL: {
    text: 'Greater Than Or Equal',
    value: 'GREATER_THAN_OR_EQUAL',
  },
  LESS_THAN: {
    text: 'Less Than',
    value: 'LESS_THAN',
  },
  LESS_THAN_OR_EQUAL: {
    text: 'Less Than Or Equal',
    value: 'LESS_THAN_OR_EQUAL',
  },
  NOT: {
    text: 'Not Any of the Following',
    value: 'NOT',
  },
};

export const surveyPageSize = 20;

export const REVIEW_STATUS = {
  APPROVED: 'Approved',
  PENDING: 'Pending',
  QUARANTINED: 'Quarantined',
};

export const REVIEW_STATUS_NUMERIC = {
  Approved: 2,
  Pending: 1,
  Quarantined: 3,
};
